import { render, staticRenderFns } from "./AtlassianLanding.vue?vue&type=template&id=af9d9ff6&"
import script from "./AtlassianLanding.vue?vue&type=script&lang=ts&"
export * from "./AtlassianLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports